import {
  Container,
  Col,
  Icons,
  SideDrawerItem,
  useHooks,
  breakpoints,
} from '@everlywell/leaves';
import React, { useState } from 'react';

import MobileFilterMenu from './MobileFilterMenu';
import * as S from './styles';

export type PageControlSectionProps = {
  handleCategorySelect: (categoryIndex: number) => void;
  allTabItems: string[];
  categoryIndex: number;
  numberOfResults: number;
};

export const PageControlSection: React.FC<PageControlSectionProps> = ({
  handleCategorySelect,
  allTabItems,
  categoryIndex,
  numberOfResults,
}) => {
  const [showFilterDrawer, setShowFilterDrawer] = useState<boolean>(false);

  const handleCategoryClick = (i: number) => {
    handleCategorySelect(i);
    setTimeout(() => {
      setShowFilterDrawer(false);
    }, 500);
  };

  const windowSize = useHooks.useWindowSize();
  const isTabletUp = windowSize?.width
    ? windowSize.width >= breakpoints.forTabletHorizontalUp
    : false;

  return (
    <Container>
      <S.Row center="xs" middle="sm">
        {isTabletUp ? (
          <S.TabMenuWrapper xs={12}>
            <S.TabMenu
              onItemSelect={handleCategorySelect}
              initialActiveIndex={categoryIndex}
              ariaLabel="Product Category Filter"
              ariaControls="productGrid"
              id="tabProduct"
            >
              {allTabItems.map((item, i) => (
                <S.Tab key={i}>{item}</S.Tab>
              ))}
            </S.TabMenu>
          </S.TabMenuWrapper>
        ) : (
          <S.TabMenuWrapper xs={12} />
        )}
        <Col xs={12} sm={6}>
          <S.DisplayTitle data-testid="pipSelectedCategory">
            {allTabItems[categoryIndex]}
          </S.DisplayTitle>
        </Col>
        <S.MobileFilter xs={12} sm={6}>
          <S.SideDrawerItemWrapper>
            <S.NumberOfResults>{numberOfResults} results</S.NumberOfResults>
            {!isTabletUp ? (
              <S.SideDrawerTrigger>
                <SideDrawerItem
                  active={showFilterDrawer}
                  icon={<Icons.Refine />}
                  label="Filter &amp; Sort"
                  onClickHandler={() => setShowFilterDrawer(!showFilterDrawer)}
                  handleClose={() => setShowFilterDrawer(false)}
                  drawerChildren={
                    <MobileFilterMenu
                      categories={allTabItems}
                      onItemSelect={handleCategoryClick}
                      activeIndex={categoryIndex}
                      ariaLabel="Product Category Filter"
                      ariaControls="productGrid"
                    />
                  }
                />
              </S.SideDrawerTrigger>
            ) : null}
          </S.SideDrawerItemWrapper>
        </S.MobileFilter>
      </S.Row>
    </Container>
  );
};

export default PageControlSection;
